import type { TJSONSchema } from "@artifact-management/json-dynamic-form";
import type { IAddress } from "@bbj-types/address";
import { Address } from "@inputs/autocomplete/Address";
import { type FieldValues, type Path, type PathValue, useController } from "react-hook-form";
import type { IFormGenInputProps } from "./index";

export const FormGenInputAddress = <Schema extends TJSONSchema, T extends FieldValues>({
  control,
  uiSchemaElement,
}: IFormGenInputProps<Schema, T>) => {
  const { field, fieldState } = useController({
    control,
    name: uiSchemaElement.scope as unknown as Path<T>,
    defaultValue: null as PathValue<T, Path<T>>,
  });

  return (
    <Address
      label={uiSchemaElement.label}
      value={(field.value ?? null) as IAddress | null}
      onChange={(_, value) => field.onChange(value)}
      onBlur={field.onBlur}
      size="small"
      fullWidth
      disabled={uiSchemaElement.disabled}
      TextFieldProps={{
        error: Boolean(fieldState.error),
        helperText: fieldState.error?.message,
      }}
    />
  );
};
